import { useSyncExternalStore } from 'react'
import { getAuthSnapshot, subscribeAuth } from '@/lib/auth/auth'

export function useAuth() {
  return useSyncExternalStore(subscribeAuth, getAuthSnapshot, getAuthSnapshot)
}
